<script>
  import { saveAs } from 'file-saver';
  import { month, year, selectedBackground } from '../stores.js';
  import { months } from '../date.utils.js';
  import { backgrounds } from '../data/backgrounds.js';

  export let svelteCanvas;

  /*
  filename should include:
  - month-year
  - file description
  - randomString
  */

  // https://github.com/Z4P0/cowsay-svelte/blob/main/src/lib/components/DownloadButton.svelte
  // ---
  const randomString = (length) => {
    let result = "";
    let characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  };
  const download = () => {
    const wallpaperFilename = backgrounds[$selectedBackground].name.replaceAll(' ', '-');
    svelteCanvas.getCanvas().toBlob((blob) => {
      saveAs(blob, `${$year}-${months[$month].toLowerCase()}-${wallpaperFilename.toLowerCase()}-${randomString(5)}.png`);
    });
  };
  // ---

</script>

<div class="form-actions">
  <button on:click={download} type="button">Download</button>
</div>

<style>
  button {
    display: block;
    font-weight: bold;
    line-height: 1;
    padding: .6875em .5em;
    text-align: center;
    width: 100%;
  }
  .form-actions {
    margin: 2em 0;
  }
</style>
